import { useState, useEffect } from 'react';

import { useServices } from '@/services/useServices';
import { GET_STOCK } from '@/constants/product';

export const useRemainingQty = (item: { stock?: number, partnumber?: string }, storeId: string) => {
  const [remainingQty, setRemainingQty] = useState(item?.stock ?? 0);
  const { productsService } = useServices();

  useEffect(() => {
    if (item) {
      if (item.stock === undefined) {
        productsService.getStock(item.partnumber, storeId, GET_STOCK.SHORT).then((inStock) => {
          setRemainingQty(+inStock.remainingQuantity);
        }).catch(() => {
          setRemainingQty(0);
        });
      } else {
        setRemainingQty(item.stock);
      }
    }
  }, [item]);

  return remainingQty;
};
